// extracted by mini-css-extract-plugin
module.exports = {"backgroundBoxParent":"BluredBackground_backgroundBoxParent__3V7hH","backgroundBox":"BluredBackground_backgroundBox__CTJro"};